import { render, staticRenderFns } from "./Journey.vue?vue&type=template&id=cfab6e24&scoped=true&"
import script from "./Journey.vue?vue&type=script&lang=js&"
export * from "./Journey.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfab6e24",
  null
  
)

export default component.exports